import { createSlice } from "@reduxjs/toolkit";

const intialFileUploadList = [];

const fileUploadListSlice = createSlice({
  name: "fileUploadList",
  initialState: intialFileUploadList,
  reducers: {
    setFileUploadData: (state, action) => {
      state.push(...action.payload);
    },
    removeFileUploadData: (state, action) => {
      const index = action.payload;
      if (state[index]) {
        state[index].isDeleted = true;
      }
    },
    removeAllFileUploadData: (state) => {
      state.forEach((item) => {
        item.isDeleted = true;
      });
    },
    updateFileUploadData: (state, action) => {
      const { index, data } = action.payload;
      if (state[index] && state[index].isFolder && data.bytesUploaded) {
        state[index].totalBytesUploaded = (state[index].totalBytesUploaded ?? 0) + data.bytesUploaded;
        const percentageComplete = Math.floor((state[index].totalBytesUploaded * 100) / state[index].size);
        state[index].progress = percentageComplete;
      }
      state[index] = { ...state[index], ...data };
    },
    documentChange: (state, action) => {
      const { index, data } = action.payload;
      const location = state[index].location;
      let documentType = [data];
      if (Array.isArray(state[index].documentType)) {
        documentType = [...state[index].documentType, data];
      }
      const isMetadataPending =
        !location ||
        (Array.isArray(location) && !location.length) ||
        !documentType ||
        (Array.isArray(documentType) && !documentType.length);
      state[index] = { ...state[index], documentType, isMetadataPending };
    },
    documentRemove: (state, action) => {
      const { index, data } = action.payload;
      const location = state[index].location;
      const documentType = state[index].documentType.filter((d) => d !== data);
      const isMetadataPending =
        !location ||
        (Array.isArray(location) && !location.length) ||
        !documentType ||
        (Array.isArray(documentType) && !documentType.length);
      state[index] = { ...state[index], documentType, isMetadataPending };
    },
    locationChange: (state, action) => {
      const { index, data } = action.payload;
      const documentType = state[index].documentType;
      let location = [data];
      if (Array.isArray(state[index].location)) {
        location = [...state[index].location, data];
      }
      const isMetadataPending =
        !location ||
        (Array.isArray(location) && !location.length) ||
        !documentType ||
        (Array.isArray(documentType) && !documentType.length);
      state[index] = { ...state[index], location, isMetadataPending };
    },
    locationRemove: (state, action) => {
      const { index, data } = action.payload;
      const location = state[index].location.filter((d) => d !== data);
      const documentType = state[index].documentType;
      const isMetadataPending =
        !location ||
        (Array.isArray(location) && !location.length) ||
        !documentType ||
        (Array.isArray(documentType) && !documentType.length);
      state[index] = { ...state[index], location, isMetadataPending };
    },
    emptyFileUploadData: () => intialFileUploadList,
  },
});

const fileUploadPropertiesSlice = createSlice({
  name: "fileUploadProperties",
  initialState: {},
  reducers: {
    setFileUploadProperties: (state, action) => {
      Object.assign(state, action.payload);
    },
    updateFileUploadData: (state, action) => {
      const data = action.payload;
      if (data.spaceId && data.hierarchyId && state[`${data.spaceId}_${data.hierarchyId}`]) {
        const { fileUploadList = [] } = state[`${data.spaceId}_${data.hierarchyId}`];
        const index = data.index;
        const list = [...fileUploadList];
        if (list[index] && list[index].isFolder && data.data.bytesUploaded) {
          list[index].totalBytesUploaded = (list[index].totalBytesUploaded ?? 0) + data.data.bytesUploaded;
          const percentageComplete = Math.floor((list[index].totalBytesUploaded * 100) / list[index].size);
          list[index].progress = percentageComplete;
        }
        list[index] = { ...list[index], ...data.data };
        state[`${data.spaceId}_${data.hierarchyId}`] = {
          ...state[`${data.spaceId}_${data.hierarchyId}`],
          fileUploadList: list,
        };
      }
    },
    emptyFileUploadData: () => ({}),
  },
});

const currentFileUploadPropertiesSlice = createSlice({
  name: "currentFileUploadProperties",
  initialState: {},
  reducers: {
    setCurrentFileUploadProperties: (_state, action) => action.payload,
  },
});

const fileUploadStateSlice = createSlice({
  name: "fileUploadState",
  initialState: "CLOSED",
  reducers: {
    minimiseFileUpload: () => "MINIMISED",
    maximiseFileUpload: () => "MAXIMISED",
    closeFileUpload: () => "CLOSED",
  },
});

const isFileVersionUploadingSlice = createSlice({
  name: "isFileVersionUploading",
  initialState: false,
  reducers: {
    setIsFileVersionUploading: (_state, action) => action.payload,
  },
});

const fileVersionUploadStateSlice = createSlice({
  name: "fileVersionUploadState",
  initialState: "CLOSED",
  reducers: {
    minimiseFileVersionUpload: () => "MINIMISED",
    maximiseFileVersionUpload: () => "MAXIMISED",
    closeFileVersionUpload: () => "CLOSED",
  },
});

export const {
  setFileUploadData,
  removeFileUploadData,
  removeAllFileUploadData,
  updateFileUploadData,
  documentChange,
  documentRemove,
  locationChange,
  locationRemove,
  emptyFileUploadData,
} = fileUploadListSlice.actions;

export const {
  setFileUploadProperties,
  updateFileUploadData: updateFileUploadProperties,
  emptyFileUploadData: emptyFileUploadProperties,
} = fileUploadPropertiesSlice.actions;

export const { setCurrentFileUploadProperties } = currentFileUploadPropertiesSlice.actions;

export const { minimiseFileUpload, maximiseFileUpload, closeFileUpload } = fileUploadStateSlice.actions;

export const { setIsFileVersionUploading } = isFileVersionUploadingSlice.actions;

export const { minimiseFileVersionUpload, maximiseFileVersionUpload, closeFileVersionUpload } =
  fileVersionUploadStateSlice.actions;

export const fileUploadList = fileUploadListSlice.reducer;
export const fileUploadProperties = fileUploadPropertiesSlice.reducer;
export const currentFileUploadProperties = currentFileUploadPropertiesSlice.reducer;
export const fileUploadState = fileUploadStateSlice.reducer;
export const isFileVersionUploading = isFileVersionUploadingSlice.reducer;
export const fileVersionUploadState = fileVersionUploadStateSlice.reducer;
